import SavingsIcon from './SavingsIcon'

export default SavingsIcon
